import { useCallback, useEffect, useState } from 'react';

export type TSection = 'sign-in' | 'sign-up';

interface ISectionsHookParams {
  initialSection: TSection;
}

const sectionFromHash = (): TSection | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const section = window.location.hash.split('#')[1];
  if (section === 'sign-up' || section === 'sign-in') {
    return section;
  }

  return null;
};

export const useSections = ({ initialSection }: ISectionsHookParams) => {
  const [currentSection, setCurrentSection] =
    useState<TSection>(initialSection);
  const [hasReadHash, setHasReadHash] = useState(false);

  if (typeof window !== 'undefined' && !hasReadHash) {
    setHasReadHash(true);
    const hashSection = sectionFromHash();
    if (hashSection) {
      setCurrentSection(hashSection);
    }
  }

  const handleSwitchSection = useCallback(() => {
    setCurrentSection(section => {
      switch (section) {
        case 'sign-in':
          return 'sign-up';
        case 'sign-up':
          return 'sign-in';
      }
    });
  }, []);

  useEffect(() => {
    if (currentSection) {
      window.location.hash = currentSection;
    }
  }, [currentSection]);

  return {
    currentSection,
    handleSwitchSection,
  };
};
